module.exports = __webpack_public_path__ + "9797ad3dd1ee5b051c4966bca2f27e81.svg";